<template>
  <div class="tile_container container">
    <Tile title="Tiles" icon="columns" :startUpAnimation="false">
      <p style="text-align:left;">Add and edit here your tiles, displayed on the dashboard.<br>
      You can also rearrange the order of the tiles by simply drag and drop them in the list below.</p>
      <v-draggable handle=".sorter" v-model="tiles" style="text-align:left;" class="flexbox">
        <div v-for="tile in tiles" :key="tile.id" style="margin-top:20px;">
          <div class="sorter" style="display:inline-block;margin-right: 10px;vertical-align:top;cursor:move;">
            <Icon icon="grip-lines" />
          </div>
          <div style="display:inline-block;margin-right: 10px;vertical-align:top;">
            <Icon :icon="tile.data.icon" />
          </div>
          <div style="display:inline-block;">
            {{ tile.data.title }}
            <br />
            <span class="sub_path">{{ tile.data.path }}</span>
          </div>
          <div style="float:right;">
            <i class="fal fa-pencil" @click="editTile(tile.id)" style="font-size:20px;cursor:pointer;margin-right:15px;"></i>
            <i class="fal fa-trash" @click="deleteTile(tile.id)" style="font-size:20px;cursor:pointer;"></i>
          </div>
        </div>
      </v-draggable>
      <button style="cursor:pointer;margin-top:30px;width:50%;" @click="addTile">
          <i class="fal fa-plus" style="font-size:23px;"></i>
          <span style="margin-left: 30px;">New tile</span>
      </button>
    </Tile>
  </div>
</template>

<script>
import { storage, auth } from "../schmucklicloud";

export default {
  data() {
    return {
      tiles: []
    };
  },
  mounted() {
    var session_token = window.localStorage.getItem("session_token");
    auth.checkSession(session_token).then(function(response){
      if (response.isOK) {
        this.loadTiles();
      } else {
        this.$router.replace("/login");
      }
    }.bind(this));
  },
  methods: {
    loadTiles() {
      storage.getAll("tiles").then(
        function(response) {
          if (response.isOK) {
            this.tiles = response.data.sort(function (a, b) {
              return a.data.order - b.data.order;
            });
          }
        }.bind(this)
      );
    },
    deleteTile(id) {
      event.preventDefault();
      storage.delete("tiles", id).then(function (response) {
          if(response.isOK) {
              this.loadTiles();
          }
      }.bind(this));
    },
    editTile(id) {
      event.preventDefault();
      this.$router.push({name: "EditTile", params: {id: id}});
    },
    addTile() {
      this.$router.push({name: "AddTile"});
    }
  },
  watch: {
    tiles(current_tiles) {
      current_tiles.forEach(function (tile, index) {
        var object = Object.assign(tile.data, {order: index});
        storage.update("tiles", tile.id, object);
      });
    }
  }
};
</script>

<style scoped>
.management {
  color: black;
  text-align: left;
}

.sub_path {
  color: grey;
  font-size: 10px;
}

.flexbox {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
}

.flexbox > div {
  min-width: calc(33% - 20px);
  margin: 10px;
}

@media only screen and (max-width: 900px) {
  .flexbox > div {
    min-width: 100%;
  }
}
</style>